import $ from "jquery";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const storySwiper = document.getElementsByClassName('js-storySwiper');
let swiper;
if(storySwiper.length > 0){
  for(let i = 0; i < storySwiper.length; i++) {
    swiper = new Swiper('#js-storySwiper' + i, {
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          spaceBetween: 0,
        },
      },
      loop: true,
      loopedSlides: 3,
      slidesPerView: "auto",
      spaceBetween: 0,
      speed: 12000,
    });
  }
}
